import { StudyYearContent } from "../../components/configuration";

export default function StudyYear() {
  return (
    <>
      <StudyYearContent />
    </>
  );
}
